module.exports = __webpack_public_path__ + "img/p-male-dgrey.093cee33.svg";